module.exports = __webpack_public_path__ + "img/zhuozi_dyjy.1fde6ff2.png";